import React from 'react';
import { Link } from 'gatsby';
import classNames from 'classnames';
import Img from 'gatsby-image';
var Tiles = function Tiles(props) {
    return /*#__PURE__*/ React.createElement("section", {
        className: classNames('tiles__container', {
            'tiles__container--grid': props.grid
        })
    }, props.tiles.map(function (tile, index) {
        return /*#__PURE__*/ React.createElement("figure", {
            key: index,
            className: classNames('tiles__tile', {
                'tiles__tile--link': tile.link
            })
        }, tile.link ? /*#__PURE__*/ React.createElement(Link, {
            to: tile.link
        }, /*#__PURE__*/ React.createElement("div", {
            className: "tiles__tile__image"
        }, /*#__PURE__*/ React.createElement(Img, {
            fluid: tile.image.fluid
        })), /*#__PURE__*/ React.createElement("div", {
            className: "tiles__tile__copy"
        }, tile.copy.headline.span && /*#__PURE__*/ React.createElement("h2", null, tile.copy.headline.span), tile.copy.headline.h1 && /*#__PURE__*/ React.createElement("h1", null, tile.copy.headline.h1), tile.copy.text && /*#__PURE__*/ React.createElement("p", null, tile.copy.text), tile.copy.link && /*#__PURE__*/ React.createElement(Link, {
            to: tile.copy.link.linksTo
        }, tile.copy.link.text))) : /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
            className: "tiles__tile__image"
        }, /*#__PURE__*/ React.createElement(Img, {
            fluid: tile.image.fluid
        })), /*#__PURE__*/ React.createElement("div", {
            className: "tiles__tile__copy"
        }, tile.copy.headline.span && /*#__PURE__*/ React.createElement("h2", null, tile.copy.headline.span), tile.copy.headline.h1 && /*#__PURE__*/ React.createElement("h1", null, tile.copy.headline.h1), tile.copy.text && /*#__PURE__*/ React.createElement("p", null, tile.copy.text), tile.copy.link && /*#__PURE__*/ React.createElement("a", {
            href: tile.copy.link.linksTo
        }, tile.copy.link.text))));
    }));
};
export default Tiles;
